import React from 'react';
import { KTIcon } from '../../../../../_metronic/helpers';

const ProductDetailImages = ({ images, title }) => {
    return (
        <div className="card card-flush py-4">
            <div className="card-header">
                <div className="card-title">
                    <h2>{title}</h2>
                </div>
            </div>
            {images && images.map((item, index) => {
                return (
                    <div key={item.id} className="card-body text-center">
                        <div className="image-input image-input-empty image-input-outline image-input-placeholder mb-3 " >
                            <div className='image-input-wrapper'>
                                <img src={item.link} height="100%" width="100%" alt={item.id}></img>
                            </div>
                        </div>
                        <div className="text-muted fs-7"></div>
                    </div>
                )
            })}
            {images && images.length === 0 ? <div className='symbol symbol-75px me-5 text-center'><KTIcon iconName='parcel-tracking' className='fs-5x' /></div> : null}
        </div>
    );
};

export default ProductDetailImages;
